import { type Inbox } from 'entities/Inbox/model/Inbox'

type IGetManageableInboxesParams = {
  inboxes: Inbox[]
  userId?: number
  canManageOrganizationInboxes: boolean
}

export const getManageableInboxes = ({
  inboxes,
  userId,
  canManageOrganizationInboxes,
}: IGetManageableInboxesParams): Inbox[] => {
  if (canManageOrganizationInboxes) return inboxes

  if (!userId) return []

  return inboxes.filter((inbox) => inbox.ownerId === userId)
}
